import { render, staticRenderFns } from "./compDetails.vue?vue&type=template&id=4fcb3e33&scoped=true&"
import script from "./compDetails.vue?vue&type=script&lang=js&"
export * from "./compDetails.vue?vue&type=script&lang=js&"
import style0 from "./compDetails.vue?vue&type=style&index=0&id=4fcb3e33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb3e33",
  null
  
)

export default component.exports